import { SxProps } from '@mui/material'
import { STYLE_UNITS } from '@/styles'
import { inputClasses } from './Input.data'

interface InputStyles {
  container: SxProps
  inputWrapper: SxProps
  inputBase: SxProps
  input: SxProps
  errorText: SxProps
}

const inputPaddingX = 1.5
export const inputDimensions = {
  inputGap: 1,
  inputGapInPx: 1 * STYLE_UNITS.SPACING_MULTIPLIER, // 8px
  inputPaddingX: inputPaddingX,
  inputPaddingXInPx: inputPaddingX * STYLE_UNITS.SPACING_MULTIPLIER, // 12px
  adornmentSize: 16,
}

export const inputStyles: InputStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.75,
    position: 'relative',
    flex: 1,
  },
  inputWrapper: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'border.primary',
    borderRadius: 2,
    px: inputDimensions.inputPaddingX,
    py: 1,
    display: 'flex',
    alignItems: 'center',
    gap: inputDimensions.inputGap,
    color: 'text.primary900',
    minHeight: 44,
    outlineWidth: 1,
    outlineStyle: 'solid',
    outlineColor: 'transparent',
    transition: 'all .3s',

    [`.${inputClasses.label.placement.inside} &`]: {
      pt: 1.5,
      pb: 0,
    },

    [`.${inputClasses.state.focused} &`]: {
      borderColor: 'border.brand',
      outlineColor: 'border.brand',
    },
    [`.${inputClasses.state.error} &`]: {
      color: 'error.main',
      borderColor: 'error.main',
      outlineColor: 'error.main',
    },
  },
  inputBase: {
    flex: 1,
  },
  input: {
    p: 0,
    color: 'text.primary900',
    typography: 'textMd',
    [`.${inputClasses.label.placement.inside} &`]: {
      '&::placeholder': {
        opacity: 0,
      },
    },
  },
  errorText: {
    typography: 'textSm',
    color: 'error.main',
  },
}
